// bif iq brand assets (public/brand). tone="white" for dark backgrounds.
export const BRAND = { green: "#083D1E", lime: "#82B401" };

export function Logo({ variant = "full", tone = "color", className = "h-10" }) {
    const src = `/brand/bifiq-${variant}${tone === "white" ? "-white" : ""}.png`;
    return <img src={src} alt="BIF IQ — From Feed to Performance" className={`w-auto max-w-full object-contain self-start select-none ${className}`} draggable={false} data-testid={`logo-${variant}`} />;
}
